export class IconService {
   async postIcon(tenantId: number, icon: any) {
      const formData = new FormData();
      formData.append('icon', icon);
      const response = await http.post(`/tenants/${tenantId}/icon`, formData);
      return response.data;
   }
}
